<script setup lang="ts"></script>
<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3.49988C12.5523 3.49988 13 3.94759 13 4.49988V17.0858L17.293 12.7928C17.6835 12.4023 18.3165 12.4023 18.707 12.7928C19.0976 13.1834 19.0976 13.8164 18.707 14.2069L13.4141 19.4999C12.633 20.2808 11.367 20.2808 10.5859 19.4999L5.29297 14.2069C4.90244 13.8164 4.90244 13.1834 5.29297 12.7928C5.68349 12.4023 6.31651 12.4023 6.70703 12.7928L11 17.0858V4.49988C11 3.94759 11.4477 3.49988 12 3.49988Z"
      fill="currentColor"
    />
  </svg>
</template>
